import axios from 'axios';
import apiService from '../apiService';
import { getDic } from '../../assets/i18n/dictionary';

export default async function uploadFileToS3(
  eventId = "",
  guestId = "",
  base64 = "",
) {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().externalBase}public/api/files/credenciamento/gravarFoto`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiService.getFaceRecognitionToken(),
      },
      data: {
        idEvento: eventId,
        idParticipante: guestId,
        base64: base64,
      },
    });

    if (!_ret.data.Success) {
      let _message = errorHandler(_ret.data.Message);
      return _message;
    }

    return '';
  } catch (error) {
    console.error("Error uploadFileToS3", error);
    throw error;
  }

  function errorHandler(message = '') {
    if (message.toLowerCase().includes('nenhum rosto detectado na imagem')) {
      return getDic("nenhum-rosto-detectado");
    }
    if (message.toLowerCase().includes('erro ao processar imagem')) {
      return getDic("erro-ao-processar-imagem");
    }
    if (message.toLowerCase().includes('não encontrei rosto na imagem')) {
      return getDic("nao-ha-rosto-na-imagem");
    }
    if (message.toLowerCase().includes('confiança da imagem insuficiente')) {
      return getDic("fique-local-iluminacao-adequada");
    }
    return message;
  }
}
